import { ReactNode } from 'react'
import { Loading } from '@resiliatech/birdsong'
import { WidgetLoadingContainer } from './ImpactReportDashboard.styled'

interface WithLoadingProps {
  children: ReactNode
  height?: string
  loading: boolean
  showBorderAndPadding?: boolean
  width: string
}

export const WithWidgetLoading = ({
  children,
  height,
  loading,
  showBorderAndPadding = true,
  width,
}: WithLoadingProps) => (
  <WidgetLoadingContainer
    height={height}
    loading={loading}
    showBorderAndPadding={showBorderAndPadding}
    width={width}
  >
    {loading ? <Loading /> : children}
  </WidgetLoadingContainer>
)
